<template>
    <footer class="app-footer">
        <div class="footer-content">
            <span>Powered by </span>
            <strong>Blastness SPA</strong>
        </div>
    </footer>
</template>


<script>

export default {
    name: 'Footer',
    methods: {},
    computed: {},

}
</script>

